import React from 'react'
import { Link } from 'react-router-dom';
import { useMyProducts } from '../../../Hook/App'
import { fromNow } from '../../../Utils';
function Index() {
    const { setTab, tab, ShowAccordion, accordion, userProducts } = useMyProducts();

    const Item = ({ item }) => {
        const { images, status, category, name, price, viewStatus, views, page, id, created_at } = item;

        let textStatus = '';
        switch (status) {
            case 'accept':
                textStatus = 'تایید شده';
                break;

            case 'delete':
                textStatus = 'حذف شده';
                break
            case 'new':
                textStatus = 'در انتظار تایید';
                break
            case 'reject':
                textStatus = 'رد شد';
                break

        }
        return (
            <div className="item">
                <Link to={"/CensusAndVisit/" + id}  state={{ item: item }} className="d-flex">
                    <div className="right">
                        <div className="img">
                            <img src={images[0]} alt="image" />
                        </div>
                        <div className={status == "accept" ? "accept" : "deleted"}>
                            {textStatus}
                        </div>
                    </div>
                    <div className="item-info w-100">
                        <div className="d-flex align-items-center justify-content-between">
                            <p>{name}</p>
                            <p>{category && category.title}</p>
                        </div>
                        <div className={` d-flex justify-content-between`}>
                            <span>{price == 'توافقی' ? price : parseInt(price).toLocaleString() + " تومان "}</span>
                            <span>{fromNow(new Date(created_at))}</span>
                        </div>
                    </div>
                </Link>
                {status == "accept" && <div>
                    <div className="detials">
                        <div className="row">
                            <div className="col-4">
                                <Link to={"/CensusAndVisit/" + id} state={{ item: item }}>
                                    <button className="btn" onClick={ShowAccordion}>
                                        <i class="text-danger far fa-chart-bar"></i>
                                        <span>آمار بازدید</span>
                                    </button>
                                </Link>
                            </div>
                            <div className="col-4">
                                <Link to={"/DeleteItem/" + id}>
                                    <button className="btn borderx">
                                        <i class="fas fa-trash"></i>
                                        <span>حذف</span>
                                    </button>
                                </Link>
                            </div>
                            <div className="col-4">
                                <Link to={"/EditItem/" + id} state={{ item: item }}>
                                    <button className="btn">
                                        <i class="fas fa-pen"></i>
                                        <span>ویرایش</span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
     
                </div>}
                {/* {status == "delete" && <button onClick={() => { }} className="activing">
                    <span>فعال سازی</span>
                    <i class="fas fa-check"></i>
                </button>} */}
            </div>
        )
    }
    const Content = () => {
        return (

            tab == "inactive" ?
                userProducts ? userProducts.data.filter((item) => item.status == "delete").map((item, i) => {
                    return <Item item={item} key={i} />;
                }) : null
                :
                userProducts ? userProducts.data.filter((item) => item.status == "accept").map((item, i) => {
                    return <Item item={item} key={i} />;
                }) : null

        )
    }
    return (
        <div>
            {/* <div className="tab">
                <div className="d-flex">
                    <button onClick={() => setTab("active")} style={tab == "active" ? { borderBottomColor: "#2185e2" } : { border: "none" }} className='advertising-title'>
                        فعال
                    </button>
                    <button onClick={() => setTab("inactive")} style={tab == "inactive" ? { borderBottomColor: "#2185e2" } : { border: "none" }} className='advertising-title'>
                        غیر فعال
                    </button>
                </div>
            </div> */}
            <div className="items">
                {/* <Content /> */}
                {userProducts && userProducts.data.map((item, i) => {
                    return <Item item={item} key={i} />;
                })
                }
            </div>
        </div>
    )
}
export default Index